/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Ref, Ref$inboundSchema } from "./ref.js";

/**
 * The position of the value on the shelf. This is used to determine the alignment of the value on the shelf.
 */
export const ValuePosition = {
  Top: "top",
  Bottom: "bottom",
} as const;
/**
 * The position of the value on the shelf. This is used to determine the alignment of the value on the shelf.
 */
export type ValuePosition = OpenEnum<typeof ValuePosition>;

/**
 * The variant of the value.
 */
export const AnimaticValueShelfItemVariant = {
  Stage: "stage",
  Name: "name",
  Default: "default",
  NotInSequence: "not_in_sequence",
} as const;
/**
 * The variant of the value.
 */
export type AnimaticValueShelfItemVariant = OpenEnum<
  typeof AnimaticValueShelfItemVariant
>;

/**
 * The configuration of the shelf item.
 */
export type AnimaticValueShelfItem = {
  /**
   * Whether the item should be hidden from the shelf.
   */
  hidden: boolean;
  /**
   * A reference to a reading or setting.
   */
  ref?: Ref | undefined;
  /**
   * The value to display for the item
   */
  value?: string | undefined;
  /**
   * Optional, value formatter to apply to the value
   */
  valueFormatter?: string | undefined;
  /**
   * The position of the value on the shelf. This is used to determine the alignment of the value on the shelf.
   */
  valuePosition: ValuePosition;
  /**
   * The variant of the value.
   */
  variant: AnimaticValueShelfItemVariant;
};

/** @internal */
export const ValuePosition$inboundSchema: z.ZodType<
  ValuePosition,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ValuePosition);

/** @internal */
export const AnimaticValueShelfItemVariant$inboundSchema: z.ZodType<
  AnimaticValueShelfItemVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticValueShelfItemVariant);

/** @internal */
export const AnimaticValueShelfItem$inboundSchema: z.ZodType<
  AnimaticValueShelfItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  hidden: types.boolean().default(false),
  ref: types.optional(Ref$inboundSchema),
  value: types.optional(types.string()),
  value_formatter: types.optional(types.string()),
  value_position: ValuePosition$inboundSchema.default("top"),
  variant: AnimaticValueShelfItemVariant$inboundSchema.default("default"),
}).transform((v) => {
  return remap$(v, {
    "value_formatter": "valueFormatter",
    "value_position": "valuePosition",
  });
});

export function animaticValueShelfItemFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueShelfItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueShelfItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueShelfItem' from JSON`,
  );
}
